
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const XdToAi = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const isProduction = process.env.NEXT_PUBLIC_XD2SKETCH_BACKEND_HOST.includes(
    "api.magicul.io",
  );
  return (
    <>
      <Head pageNamespace="page/XDToAI" ogImage="/images/xd2ai-og-image.jpg" />

      <MagicianSection
        title={t("page/XDToAI:title")}
        subtitle={t("page/XDToAI:subtitle")}
        magicianLogoFile="ai"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled={!!isProduction} />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/XDToAI:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/xd-to-ai-example.png",
          alt: "Adobe XD to Adobe Illustrator converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t("page/XDToAI:section/apiTeaser.apiTeaserElements", null, {
          returnObjects: true,
        })}
      />
      <VideoSection
        title={t("page/XDToAI:section/videoSection.title")}
        subtitle={
          ((
            <Trans
              i18nKey="page/XDToAI:section/videoSection.subtitle"
              components={[
                <p key="0" />,
                <p key="1" style={{ paddingTop: 20 }} />,
              ]}
            />
          ) as unknown) as string
        }
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/figma-to-illustrator-converted-file-elements.jpg",
        }}
        cta={{
          title: t("common:actions.signUp"),
          scrollToId: "upload",
        }}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.convertsComponentsSymbols"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "ADOBEXD",
            image: "/images/xd-preview.jpg",
            title: "Adobe XD Demo Preview",
          },
          to: {
            iconType: "AI",
            image: "/images/illustrator-preview.jpg",
            title: "Adobe Illustrator Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection title={t("section/cta:titles.xdToAiPage")} href="#upload" />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default XdToAi;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/xd-to-ai',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  